import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { SzSpectrumBar, SzSpectrumSize } from './sz-spectrum.types';

@Component({
  selector: 'sz-spectrum',
  templateUrl: './sz-spectrum.component.html',
  styleUrls: ['./sz-spectrum.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzSpectrumComponent {
  readonly bars: InputSignal<ReadonlyArray<SzSpectrumBar>> = input.required<ReadonlyArray<SzSpectrumBar>>();
  readonly size: InputSignal<SzSpectrumSize> = input<SzSpectrumSize>('md');
  /** Normalized 0..1 value; if set, renders a horizontal dashed lime "all-time best" line at that height. */
  readonly bestEverValue: InputSignal<number | null> = input<number | null>(null);
  /** Optional label shown as a small lime tag next to the line. */
  readonly bestEverLabel: InputSignal<string | null> = input<string | null>(null);

  readonly bestEverBottom: Signal<string | null> = computed((): string | null => {
    const v: number | null = this.bestEverValue();
    if (v === null) return null;
    const clamped: number = Math.max(0, Math.min(1, v));
    return `${clamped * 100}%`;
  });

  height(value: number): string {
    const clamped: number = Math.max(0, Math.min(1, value));
    return `${Math.max(8, clamped * 100)}%`;
  }
}
